// Select all carousels on the page
const carousels = document.querySelectorAll('.album-carousel')

carousels.forEach((carousel) => {
  const albums = carousel.querySelectorAll('.album') // Albums in this carousel
  const prevButton = carousel.querySelector(
    '.carousel-button[aria-label="Previous albums"]'
  ) // Previous button for this carousel
  const nextButton = carousel.querySelector(
    '.carousel-button[aria-label="Next albums"]'
  ) // Next button for this carousel
  const albumNameDisplay = carousel.nextElementSibling // The paragraph to display album name (assumes it's the next sibling)
  let currentIndex = 0 // Starting index for this carousel

  // Function to update the classes for carousel items
  function updateCarousel() {
    albums.forEach((album, index) => {
      album.classList.remove('active', 'left', 'right') // Remove previous classes

      // Add 'active', 'left', or 'right' based on the index
      if (index === currentIndex) {
        album.classList.add('active')
      } else if (index === (currentIndex - 1 + albums.length) % albums.length) {
        album.classList.add('left')
      } else if (index === (currentIndex + 1) % albums.length) {
        album.classList.add('right')
      }
    })

    // Update the album name dynamically
    const currentAlbum = albums[currentIndex]
    if (albumNameDisplay) {
      albumNameDisplay.textContent = currentAlbum.id // Update the text of the paragraph
    }
  }

  // Event listeners for the carousel buttons
  if (prevButton) {
    prevButton.addEventListener('click', () => {
      currentIndex = (currentIndex - 1 + albums.length) % albums.length // Go to previous album
      updateCarousel()
    })
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      currentIndex = (currentIndex + 1) % albums.length // Go to next album
      updateCarousel()
    })
  }

  // Initialize the carousel
  updateCarousel()
})

document.querySelectorAll('.merch-carousel').forEach((carousel) => {
  const merchItems = carousel.querySelectorAll('.merch-item') // Select items within this carousel
  const prevButton = carousel.querySelector('.prev-merch') // Select the previous button for this carousel
  const nextButton = carousel.querySelector('.next-merch') // Select the next button for this carousel

  let currentMerchIndex = 0 // Starting index for this carousel

  // Function to update the classes for the merch carousel
  function updateMerchCarousel() {
    merchItems.forEach((item, index) => {
      item.classList.remove('active', 'left', 'right') // Remove previous classes

      // Add 'active', 'left', or 'right' based on the index
      if (index === currentMerchIndex) {
        item.classList.add('active')
      } else if (
        index ===
        (currentMerchIndex - 1 + merchItems.length) % merchItems.length
      ) {
        item.classList.add('left')
      } else if (index === (currentMerchIndex + 1) % merchItems.length) {
        item.classList.add('right')
      }
    })
  }

  // Event listeners for the merch carousel buttons
  prevButton.addEventListener('click', () => {
    currentMerchIndex =
      (currentMerchIndex - 1 + merchItems.length) % merchItems.length // Go to previous merch
    updateMerchCarousel()
  })

  nextButton.addEventListener('click', () => {
    currentMerchIndex = (currentMerchIndex + 1) % merchItems.length // Go to next merch
    updateMerchCarousel()
  })

  // Initialize the merch carousel
  updateMerchCarousel()
})
